import { render, staticRenderFns } from "./ConfigsPanel.vue?vue&type=template&id=65f633a7&scoped=true"
import script from "./ConfigsPanel.vue?vue&type=script&lang=js"
export * from "./ConfigsPanel.vue?vue&type=script&lang=js"
import style0 from "./ConfigsPanel.vue?vue&type=style&index=0&id=65f633a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f633a7",
  null
  
)

export default component.exports